// api endpoint list
const auth = {
    LOGIN: '/tokens',
    SIGNUP: '/users/self-register',
    REFRESH_TOKEN: '/tokens/refresh',
    FORGOT_PASSWORD: '/users/forgot-password',
    RESET_PASSWORD: '/users/reset-password',
    PROFILE: '/personal/profile',
}
const brands = {
    GET_BRANDS: '/v1/brands/search',
    ADD_BRAND: '/v1/brands',
    DELETE_BRAND: '/v1/brands',
    EDIT_BRAND: '/v1/brands',
}
const holidays = {
    GET_HOLIDAYS: 'v1/holidays/search',
    CREATE_HOLIDAY: 'v1/holidays',
    DEL_HOLIDAY: 'v1/holidays',
    PUT_HOLIDAY: 'v1/holidays',
}

const dashboard = {
    STATS: 'v1/dashboard',
    TIMEOFF: 'v1/timeoff/search',
    ANNOUNCEMNETS: 'v1/announcements/searchmyannouncements',
    MARKANNOUNCEMENT: 'v1/announcements',
}

const lookup = {
    GETLOCATIONS: 'v1/locations/search',
    ROLES: 'roles',
    LOOKUPUSER: 'v1/lookups/lookup',
    LEAVEPOLICY: 'v1/leavepolicy/search',
}

const onboarding = {
    USERONBOARDING: 'v1/weewildonesuser/create-user',
    GETLOCBASEDMANGER: 'v1/locations/managers?LocationId',
}

const users = {
    GETALLUSERS: 'v1/weewildonesuser/users',
    TOGGLEUSER: 'users',
    RESENDEMAIL: 'v1/weewildonesuser/resend-email',
    CHANGEPASSWORD: 'v1/weewildonesuser/change-user-password',
    DELETEUSER: 'v1/weewildonesuser',
}

const trainingprogram = {
    ADMINPROGLIST: 'v1/trainingprogram/program/created',
    CREATEPROGRAM: 'v1/trainingprogram/program',
    DELPROGRAM: 'v1/trainingprogram/program',
    EDITPROGRAM: 'v1/trainingprogram/program',
    VIEWRESOURCE: 'v1/trainingprogram/program/',
    UPLOADTASK: 'v1/trainingprogram/resource',
    DELRESOURCE: 'v1/trainingprogram/resource',
    CREATEQUESTIONNAIRE: 'v1/trainingprogram/questionnaire',
    GETASSIGNEDPROGRAMS: 'v1/trainingprogram/program/assigned',
    RESOURCEDETAILS: 'v1/trainingprogram/program/resource/',
    GETASSIGNEDUSERS: 'v1/trainingprogram/program/assigned-user/',
    LOCBASEDUSERS: 'v1/locations/managers-and-teachers?LocationId=',
    ASSIGNPROGRAM: 'v1/trainingprogram/program/assign',
    DELASSIGNUSER: 'v1/trainingprogram/program/user',
    TASKSLIST: 'v1/trainingprogram/program/{id}/assigned-resources',
    MARKASCOMPLETED: 'v1/trainingprogram/{id}/completed',
    VIEWRESOURCELINK: 'v1/resource/resource/{id}/view?type=',
    SUBMITRESOURCEQUESTIONNAIRE: 'v1/trainingprogram/questionnaire/submit',
}

const leaveTypes = {
    CREATE_LEAVE_TYPES: 'v1/leavetypes/create',
    GET_LEAVE_TYPES: 'v1/leavetypes/search',
    EDIT_LEAVE_TYPES: 'v1/leavetypes/update',
    DELETE_LEAVE_TYPES: 'v1/leavetypes/delete',
}

const leavePolicyActions = {
    CREATE_LEAVE_POLICY: 'v1/leavepolicy',
    UPDATE_LEAVE_POLICY: 'v1/leavepolicy/update',
}

const leavePolicyDetails = {
    GET_LEAVE_POLICY_DETAILS: 'v1/leavepolicy',
    UPDATE_LEAVE_POLICY_DETAILS: 'v1/leavepolicydetails',
    DELETE_LEAVE_POLICY: 'v1/leavepolicy/delete',
}

const profile = {
    SELF: 'personal/profile',
    CHANGEPASSWORD: 'personal/change-password',
    GETPERSONALINFO: 'v1/weewildonesuser/personal-info',
    UPDATEPERSONALINFO: 'v1/weewildonesuser/personal-info',
    JOBINFO: 'v1/weewildonesuser/job-info',
    UPDATEJOBINFO: 'v1/weewildonesuser/job-info',
    GETFORMSCOMPLETED: 'v1/weewildonesuser/forms-completed',
    GETTRAININGCOMPLETED: 'v1/weewildonesuser/training-completed',
    GETUSERSTATS: 'v1/timeoff/get-user-stats',
    ADDREVISION: 'v1/weewildonesuser/add-revision',
    TIMEOFFSEARCH: 'v1/timeoff/search',
    LEAVEPOLICYEDIT: 'v1/weewildonesuser/change-leave-policy',
    GETALLSTATES: 'v1/state/search',
}
const form = {
    GET_FORMS: 'v1/formmanagement/form/uploaded',
    GET_FORM: 'v1/formmanagement/form/',
    CREATE_FORM: 'v1/formmanagement/form',
    UPDATE_FORM: 'v1/formmanagement/form',
    DELETE_FORM: 'v1/formmanagement/form',
    GET_ASSIGNED_USER: '/v1/formmanagement/form/assigned-user/',
    DELETE_ASSIGNED_USER: '/v1/formmanagement/form/user',
    ASSIGN_FORM: '/v1/formmanagement/form/assign',
    FORM_ASSIGNED_TO_ME: '/v1/formmanagement/form/assigned',
    SUBMIT_FORM: '/v1/formmanagement/form/submit',
    DOWNLOAD_FORM: '/v1/resource/resource/:resourceID/view',
    DOWNLOAD_UPDLOADED_FORM:
        '/v1/formmanagement/submittedform/{userId}/view/{formId}',
}
const announcements = {
    CREATE_ANNOUNCEMENT: 'v1/announcements',
    SEARCH_ANNOUCEMENT: 'v1/announcements/search',
    DELETE_ANNOUNCEMENT: 'v1/announcements',
}

const employeeFiles = {
    GET_ALL_USERS_LIST: 'users',
    UPLOAD_EMPLOYEE_FILES: 'v1/employeefiles/upload',
    GET_ALL_EMPLOYEE_FILES: '/v1/employeefiles/created', //admin
    DELETE_EMPLOYEE_FILES: 'v1/employeefiles/delete',
    GET_EMPLOYEE_FILE: 'v1/employeefiles/', //:/{employeeFileId} //admion
    GET_EMPLOYEE_FILE_NO_ADMIN: 'v1/employeefiles/assigned', //api/v1/employeefiles/assigned
    DOWNLOAD_EMP_FILE: 'v1/resource/resource/:resourceID/view',
    // UPLOAD_EMPLOYEE_FILES: 'v1/employee-files',
    // DELETE_EMPLOYEE_FILES: 'v1/employee-files',
}
const timeoff = {
    APPLYTIMEOFF: 'v1/timeoff/apply-timeoff',
    VALIDATEDATERANGE: 'v1/timeoff/validate-daterange',
    TIMEOFFDETAIL: 'v1/timeoff/detail',
    WHOELSEISOFF: 'v1/timeoff/who-else-is-off',
    APPROVEREJECT: 'v1/timeoff',
    DELETETIMEOFFREQUEST: 'v1/timeoff',
}
const notification = {
    GET_NOTIFICATION: 'v1/notification/search', //post
    READ_NOTIFICATION: 'v1/notification/read', //put
    DELETE_NOTIFICATION: 'v1/notification/delete', //delete
}
const calendar_sync = {
    GETLOCATIONS: 'v1/locations/search',
    LOCBASEDUSERS: 'v1/locations/managers-and-teachers?LocationId=', //get
    GET_ASSIGNED_USER: '/v1/formmanagement/form/assigned-user/',
    CREATE_CALENDAR: '/v1/calendars/create-calendar',
    GET_ALL_CALENDAR: '/v1/calendars/search', //  /{id} for specific calendar
    GET_CALENDAR: '/v1/calendars/get-calendar-by-id', //  /{id} for specific calendar
    GET_CALENDAR_ASSIGNED_USERS: '/v1/calendars/assigned-user',
    DELETE_ASSIGNED_USER: '/v1/calendars/delete-user/', // delete /{calendarId}
    DELETE_CALENDAR: '/v1/calendars/delete-calendar-by-id/', //delete /{id}
    UPDATE_CALENDAR: '/v1/calendars',
}

export {
    auth,
    brands,
    holidays,
    dashboard,
    lookup,
    onboarding,
    users,
    trainingprogram,
    leaveTypes,
    leavePolicyActions,
    profile,
    leavePolicyDetails,
    form,
    announcements,
    employeeFiles,
    timeoff,
    notification,
    calendar_sync,
}
